/**
 * Repay Loan — Fundswalle-only endpoints (NOT dhanwalle.in).
 * Local dev: setupProxy forwards /payu, /Api to fundswalla.in
 */
const FUNDSWALLA_ORIGIN =
  process.env.REACT_APP_API_ORIGIN ||
  process.env.REACT_APP_TASK_API_ORIGIN ||
  "https://fundswalla.in";

const buildRepayUrl = (path) =>
  process.env.NODE_ENV === "development"
    ? path
    : `${FUNDSWALLA_ORIGIN}${path}`;

export const repayOldUserHistoryUrl = (pancard) =>
  buildRepayUrl(
    `/Api/TaskApi/oldUserHistory?pancard=${encodeURIComponent(String(pancard || "").trim())}`
  );

export const repayPayuHashUrl = () => buildRepayUrl("/payu/generatePayUHash");

/**
 * Payment return page crypto (same scheme as other Fundswalle verticals).
 * Backend encrypts respcode/response; frontend decrypts for display.
 */
export const PAYMENT_AES_KEY = "LxQY43Nc&87x8nxw";
export const PAYMENT_AES_IV = "@@@@&&&&####$$$$";

/** Reloan kickoff — encrypt lead id and open TaskApi leadid_copy on fundswalla.in */
export const reloanLeadCopyUrl = (encryptedData) =>
  `${FUNDSWALLA_ORIGIN}/Api/TaskApi/leadid_copy?data=${encodeURIComponent(
    String(encryptedData || "")
  )}`;

/** Frontend thank-you URL after PayU/Paytm (must exist as SPA route) */
export const repayPaymentSuccessUrl = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/payment-success`;
  }
  return "https://fundswalle.com/payment-success";
};
